import { Box, Button, Text } from '@domain-group/suit-theme'

import { statusColors } from '@functions/status'

import type {
  UsePublicationBookingPlannerPayload,
} from '@components/PublicationBookingPlanner/hooks/usePublicationBookingPlanner'

type RenderEditionStatusParams = {
  allPagesReleased: boolean,
  isBooked: boolean,
  isPending: boolean,
}

const renderEditionStatus = (params: RenderEditionStatusParams) => {
  const { allPagesReleased, isBooked, isPending } = params

  if (allPagesReleased){
    return (
      <Text as="span" fontSize="xsmall" width="auto" style={{ whiteSpace: 'nowrap' }}>
        Edition is <Text as="span" color={statusColors.approved} fontWeight="bold">Released</Text>
      </Text>
    )
  }

  if (isBooked){
    return (
      <Text as="span" fontSize="xsmall" width="auto" style={{ whiteSpace: 'nowrap' }}>
        Edition is <Text as="span" color={statusColors.booked} fontWeight="bold">Booked</Text>
      </Text>
    )
  }

  if (isPending){
    return (
      <Text as="span" fontSize="xsmall" width="auto" style={{ whiteSpace: 'nowrap' }}>
        Edition is <Text as="span" color={statusColors.pending} fontWeight="bold">Pending</Text>
      </Text>
    )
  }

  return null
}

interface PublicationOrderStatusProps {
  bookingPlannerPayload: UsePublicationBookingPlannerPayload,
}

const PublicationOrderStatus = (props: PublicationOrderStatusProps) => {
  const {
    bookingPlannerPayload: {
      editionData: {
        allPagesReleased,
        bookingCount,
        isBooked,
        isPending,
        releasedBookingIds,
      },
    },
  } = props

  if (!bookingCount){
    return null
  }

  return (
    <Box
      alignItems="center"
      backgroundColor="white"
      borderTop="1px solid"
      borderColor="lineColor"
      bottom="0"
      left="0"
      justifyContent="space-between"
      padding="large"
      position="absolute"
      right="0"
    >
      {renderEditionStatus({
        allPagesReleased,
        isBooked,
        isPending,
      })}

      <Button
        buttonStyle="secondaryUtility"
        size="medium"
        width="auto"
      >
        {releasedBookingIds?.length}/{bookingCount} Released
      </Button>
    </Box>
  )
}

export default PublicationOrderStatus
